<script>
import { MainMenu } from '@/api'
import FormMixin from '@/crudBases/form/FormMixin'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  mixins: [FormMixin],
  data() {
    return {
      form: {
        items: []
      },
      singleton: true,
      redirectRoute: null
    }
  },
  methods: {
    getFields() {
      return [
        new fields.Link({
          label: 'Link do kalendarium',
          modelPath: [this, 'form', 'calendar_link']
        }),
        new fields.Link({
          label: 'Link do biletów',
          modelPath: [this, 'form', 'tickets_link']
        }),

        new fields.Header({
          text: 'Odnośniki w rozwijanym menu'
        }),
        new fields.Formset({
          blankObject: { links: [] },
          modelPath: [this, 'form', 'items'],
          items: this.form.items.map((item, i) => {
            return {
              headerLabel: get(item, ['label_pl']),
              fields: [
                new fields.Input({
                  label: 'Nagłówek rozwijanej listy',
                  modelPath: [this, 'form', 'items', i, 'label'],
                  required: true,
                  multilingual: true
                }),
                new fields.Link({
                  label: 'Odnośnik',
                  modelPath: [this, 'form', 'items', i, 'link'],
                  hideLinkLabel: true
                }),
                new fields.Header({
                  type: 'h4',
                  text: 'Widoczne po rozwinieciu'
                }),
                this.getLinksFormset(this.form.items[i].links, i)
              ]
            }
          })
        })
      ]
    },
    getLinksFormset(links, itemIndex) {
      return new fields.Formset({
        modelPath: [this, 'form', 'items', itemIndex, 'links'],
        items: links.map((link, linkIndex) => {
          return {
            headerLabel: get(link, ['label_pl']),
            fields: [
              new fields.Link({
                label: 'Link',
                modelPath: [
                  this,
                  'form',
                  'items',
                  itemIndex,
                  'links',
                  linkIndex
                ]
              })
            ]
          }
        })
      })
    }
  },
  computed: {
    service() {
      return MainMenu
    }
  }
}
</script>
